import type { Distretto } from '../types'

// ─────────────────────────────────────────────────────────────────────────────
// DATI DISTRETTI — Provincia di Monza e della Brianza
// Usati da DistrictMap per etichette, colori e comuni per distretto
// ─────────────────────────────────────────────────────────────────────────────

export const DISTRETTI: Record<string, Distretto> = {
  monza: {
    id: 'monza',
    nome: 'Distretto di Monza',
    colorHex: '#0ea5e9',
    capoluogo: 'Monza',
    comuni: [
      'Brugherio', 'Monza', 'Villasanta'
    ],
  },
  carate: {
    id: 'carate',
    nome: 'Distretto di Carate Brianza',
    colorHex: '#8b5cf6',
    capoluogo: 'Carate Brianza',
    comuni: [
      'Albiate', 'Besana in Brianza', 'Biassono', 'Briosco', 'Carate Brianza', 'Lissone', 'Macherio', 'Renate', 'Sovico', 'Triuggio', 'Vedano al Lambro', 'Veduggio con Colzano', 'Verano Brianza'
    ],
  },
  desio: {
    id: 'desio',
    nome: 'Distretto di Desio',
    colorHex: '#10b981',
    capoluogo: 'Desio',
    comuni: [
      'Bovisio Masciago', 'Cesano Maderno', 'Desio', 'Limbiate', 'Muggiò', 'Nova Milanese', 'Varedo',
    ],
  },
  seregno: {
    id: 'seregno',
    nome: 'Distretto di Seregno',
    colorHex: '#f59e0b',
    capoluogo: 'Seregno',
    comuni: [
      'Barlassina', 'Ceriano Laghetto', 'Cogliate', 'Giussano', 'Lazzate', 'Lentate sul Seveso', 'Meda', 'Misinto', 'Seregno', 'Seveso'
    ],
  },
  vimercate: {
    id: 'vimercate',
    nome: 'Distretto di Vimercate',
    colorHex: '#f97316',
    capoluogo: 'Vimercate',
    comuni: [
      'Agrate Brianza', 'Aicurzio', 'Arcore', 'Bellusco', 'Bernareggio', 'Burago di Molgora', 'Busnago', 'Camparada', 'Caponago', 'Carnate', 'Cavenago di Brianza', 'Concorezzo', 'Cornate d\' Adda', 'Correzzana', 'Lesmo', 'Mezzago', 'Ornago', 'Roncello', 'Ronco Briantino', 'Sulbiate', 'Usmate Velate', 'Vimercate',
    ],
  },
}
